import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";

const StaticPage = ({ title, content }) => {
  return (
    <div className="min-h-screen bg-background py-16">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-8 text-center">{title}</h1>
        <div className="prose prose-lg mx-auto text-muted-foreground">
          {content}
        </div>
        <div className="mt-12 text-center">
          <Link to="/">
            <Button variant="outline">Tilbake til forsiden</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export const AboutPage = () => (
  <StaticPage 
    title="Om Norsk Frøhandel" 
    content={
      <>
        <p>
          Velkommen til Norsk Frøhandel – din nettbutikk for frø, planter og hageglede. Vår lidenskap er å hjelpe deg med å lykkes med din hage, balkong eller stue.
        </p>
        <p>
          Hos oss finner du et bredt utvalg av kvalitetsplanter og frø, nøye utvalgt for å trives i det norske klimaet. Våre gartnere har lang erfaring og deler gjerne sin kunnskap med deg.
        </p>
        <p>
          Vi tror på kvalitet, bærekraft og gleden av å se ting gro.
        </p>
      </>
    } 
  />
);

export const ContactPage = () => (
  <StaticPage 
    title="Kontakt Oss" 
    content={
      <div className="space-y-6">
        <p>
          Har du spørsmål om planter, stell eller vårt utvalg? Vi er her for å hjelpe deg!
        </p>
        <div className="bg-secondary/20 p-6 rounded-xl space-y-4 not-prose">
          <div className="flex flex-col">
            <span className="font-bold text-primary">Besøksadresse:</span>
            <span>Kaj Munks vei 41, 0876 Oslo</span>
          </div>
          <div className="flex flex-col">
            <span className="font-bold text-primary">Telefon:</span>
            <span>+47 932 22 359</span>
          </div>
          <div className="flex flex-col">
            <span className="font-bold text-primary">E-post:</span>
            <span>post@norskfrohandel.no</span>
          </div>
        </div>
        <p>
          <strong>Åpningstider:</strong><br/>
          Mandag - Fredag: 10 - 19<br/>
          Lørdag: 10 - 18<br/>
          Søndag: 12 - 18
        </p>
      </div>
    } 
  />
);

export const CustomerServicePage = () => (
    <StaticPage 
      title="Kundeservice" 
      content={
        <>
          <p>Her finner du informasjon om kjøpsvilkår, levering og retur.</p>
          <h3>Levering</h3>
          <p>Vi tilbyr hjemlevering i hele Oslo-området. Varer leveres normalt innen 1-3 virkedager.</p>
          <h3>Retur og reklamasjon</h3>
          <p>Planter er ferskvare, men vi har 100% kvalitetsgaranti. Er du ikke fornøyd, ta kontakt med oss umiddelbart.</p>
        </>
      } 
    />
  );
